import * as tf from '@tensorflow/tfjs';
//import { v3_masks } from "./config";
import { TFMem } from '../util/tools'

const v3_masks = {
    "3": [[6, 7, 8], [3, 4, 5], [0, 1, 2]],
    //"2": [[3, 4, 5], [1, 2, 3]]   // orig
    "2": [[3, 4, 5], [0, 1, 2]]   // matching darknet.cfg
};
//const v3_tiny_anchors = [
//  10,14, 23,27, 37,58, 81,82, 135,169, 344,319
//];



//
// src: tfjs-yolo
//
export async function yoloPostProcess(
  version,
  outputs,
  anchors,
  numClasses,
  classNames,
  imageShape,
  maxBoxes,
  scoreThreshold,
  iouThreshold
) {
  const isV3 = version.indexOf("v3") > -1;
  const [boxes, boxScores] = yoloEval(isV3, outputs, anchors, numClasses, imageShape);

  let boxes_ = [];
  let scores_ = [];
  let classes_ = [];

  const _classes = tf.argMax(boxScores, -1);
  var _boxScores = tf.max(boxScores, -1);
  //X const splitBoxScores = boxScores.split(numClasses, 1);

  console.log("41: isV3=",isV3, "  version=", version, "  boxes=", boxes, "  boxScores=", _boxScores.shape);
  //var _boxScores1 = tf.print(_boxScores, [_boxScores]);
  //X for (let i = 0; i < numClasses; i++) {
  //X const _boxScores = splitBoxScores[i].as1D();
      const nmsIndex = await tf.image.nonMaxSuppressionAsync(
          boxes,
          _boxScores,
          maxBoxes,
          iouThreshold,
          scoreThreshold
      );

      if (nmsIndex.size) {
          tf.tidy(() => {
              const classBoxes = tf.gather(boxes, nmsIndex);
              const classBoxScores = tf.gather(_boxScores, nmsIndex);
              //X const classes = tf.mul(tf.onesLike(classBoxScores), i);

              //console.log("yoloPostProcess.43: classBoxScores=", classBoxScores, "  nmsIndex=", nmsIndex);
              classBoxes.split(nmsIndex.size).map(box => {
                  boxes_.push(box.dataSync());
                  return box;  // ??
              });

              classBoxScores.dataSync().map(score => {
                  scores_.push(score);
                  return score;  // ??
              });

              classes_ = _classes.gather(nmsIndex).dataSync();

              //for(var i=0; i<scores_.length; i++) {
              //  console.log(i+": ", scores_[i]);
              //}
          });
      }
      _boxScores.dispose();
      _classes.dispose();
      nmsIndex.dispose();
  //X }

  boxes.dispose();
  boxScores.dispose();
  //X tf.dispose(splitBoxScores);

  var out_box = boxes_.map((box, i) => {
    const top = Math.max(0, box[0]);
    const left = Math.max(0, box[1]);
    const bottom = Math.min(imageShape[0], box[2]);
    const right = Math.min(imageShape[1], box[3]);
    const height = bottom - top;
    const width = right - left;
    return {
      top,
      left,
      bottom,
      right,
      height,
      width,
      score: scores_[i],
      class: classNames[classes_[i]]
    }
  });
  boxes_.dispose();
  TFMem("yoloPostProcess");
  return out_box;
}

function yoloEval(
  isV3,
  outputs,
  anchors,
  numClasses,
  imageShape
) {
  return tf.tidy(() => {
    let numLayers = 1;
    let inputShape;
    let anchorMask;

    if (isV3) {
      console.log("117: outputs=", outputs);
      numLayers = outputs.length;
      anchorMask = v3_masks[numLayers];
      console.log("yoloEval.119: numLayers=",numLayers, " outputs=",outputs)
      inputShape = outputs[0].shape.slice(1, 3).map(num => num * 32);
    } else {
      inputShape = outputs.shape.slice(1, 3);
    }

    const anchorsTensor = tf.tensor1d(anchors).reshape([-1, 2]);
    let boxes = [];
    let boxScores = [];

    for (let i = 0; i < numLayers; i++) {
      if(outputs[i] !== null) {


      // DEBUG OUTPUT
      //console.log("Layer "+i+": ", outputs[i]); // 1, 13, 13, 18
      //var x=0; const out1 = tf.gather(outputs[i], 0);
      //out1.dataSync().map(val1 => { x=x+1; if(x < 10)console.log(val1) });
      //console.log("output["+i+"]: has size=", x);

      const [_boxes, _boxScores] = yoloBoxesAndScores(
        isV3,
        isV3 ? outputs[i] : outputs,
        isV3 ? anchorsTensor.gather(tf.tensor1d(anchorMask[i], 'int32')) : anchorsTensor,
        numClasses,
        inputShape,
        imageShape
      );

      boxes.push(_boxes);
      boxScores.push(_boxScores);
      }
    };

    boxes = tf.concat(boxes);
    boxScores = tf.concat(boxScores);

    TFMem("yoloEval");
    return [boxes, boxScores];
  });
}

function yoloBoxesAndScores(
  isV3,
  feats,
  anchors,
  numClasses,
  inputShape,
  imageShape
) {
  const [boxXy, boxWh, boxConfidence, boxClassProbs] = yoloHead(isV3, feats, anchors, numClasses, inputShape);

  let boxes = yoloCorrectBoxes(boxXy, boxWh, imageShape);
  boxes = boxes.reshape([-1, 4]);
  let boxScores = tf.mul(boxConfidence, boxClassProbs);
  boxScores = tf.reshape(boxScores, [-1, numClasses]);

  //console.log("yoloBoxesAndScores.157  **** boxConfidence=", boxConfidence, "   boxClassProbs=", boxClassProbs);
  //console.log("yoloBoxesAndScores.158  **** boxes=", boxes, "   boxScores=", boxScores);

  TFMem("yoloBoxesAndScores");
  return [boxes, boxScores];
}

function yoloHead(
  isV3,
  feats,
  anchors,
  numClasses,
  inputShape
) {
  const numAnchors = anchors.shape[0];
  // Reshape to height, width, num_anchors, box_params.
  const anchorsTensor = tf.reshape(anchors, [1, 1, numAnchors, 2]);

  const gridShape = feats.shape.slice(1, 3); // height, width

  const gridY = tf.tile(tf.reshape(tf.range(0, gridShape[0]), [-1, 1, 1, 1]), [1, gridShape[1], 1, 1]);
  const gridX = tf.tile(tf.reshape(tf.range(0, gridShape[1]), [1, -1, 1, 1]), [gridShape[0], 1, 1, 1]);
  const grid = tf.concat([gridX, gridY], 3).cast(feats.dtype);

  console.log("198:  gridY=", gridY.shape, "  gridX=", gridX.shape);
  console.log("199:  grid=", grid.shape, "  gridShape=", gridShape, "  feats=", feats.shape);

  //console.log("yoloHead.183:  numAnchors=", numAnchors, "  numClasses=", numClasses);
  feats = feats.reshape([gridShape[0], gridShape[1], numAnchors, numClasses + 5]);

  const [xy, wh, con, probs] = tf.split(feats, [2, 2, 1, numClasses], 3);
  // Adjust preditions to each spatial grid point and anchor size.
  const boxXy = tf.div(tf.add(tf.sigmoid(xy), grid), gridShape.reverse());
  const boxWh = tf.div(tf.mul(tf.exp(wh), anchorsTensor), inputShape.reverse());
  const boxConfidence = tf.sigmoid(con);

  let boxClassProbs;
  if (isV3) {
    boxClassProbs = tf.sigmoid(probs);
    //console.log("yoloHead.190  **** boxClassProbs=", boxClassProbs);
  } else {
    boxClassProbs = tf.softmax(probs);
  }

  TFMem("yoloHead");
  return [boxXy, boxWh, boxConfidence, boxClassProbs];
}

export function yoloCorrectBoxes(
  boxXy,
  boxWh,
  imageShape
) {
  let boxYx = tf.concat(tf.split(boxXy, 2, 3).reverse(), 3);
  let boxHw = tf.concat(tf.split(boxWh, 2, 3).reverse(), 3);

  // Scale boxes back to original image shape.
  const boxMins = tf.mul(tf.sub(boxYx, tf.div(boxHw, 2)), imageShape);
  const boxMaxes = tf.mul(tf.add(boxYx, tf.div(boxHw, 2)), imageShape);

  const boxes = tf.concat([
    ...tf.split(boxMins, 2, 3),
    ...tf.split(boxMaxes, 2, 3)
  ], 3);

  TFMem("yoloCorrectBoxes");
  return boxes;
}

//export default yoloPostProcess;